import { Box, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { Create, FormDataConsumer, SelectInput, SimpleForm } from "react-admin";
import { SiteContryEnum } from "shared/enums/globalEnums";
import { siteCountryChoices } from "shared/enums/reactAdminChoices";
import { isFrance } from "./utils";
import { useGroupCertificationCreate } from "./hooks/useGroupCertificationCreate";
import FinlandFormFields from "./FinlandFormFields";
import { OptimizerFinlandGroupCertificationTypeEnum } from "shared/enums/opti_enums";

const GroupCertificationsCreate = () => {
  const [certifiedPower, setCertifiedPower] = useState(0);
  const [market, setMarket] = useState<OptimizerFinlandGroupCertificationTypeEnum>(
    OptimizerFinlandGroupCertificationTypeEnum.FCR_N,
  );
  const { transformFormValues, handleSuccess, handleError } = useGroupCertificationCreate();

  const countryChoices = useMemo(() => {
    return siteCountryChoices.map((choice) => ({
      ...choice,
      disabled: isFrance(choice.id as SiteContryEnum),
    }));
  }, []);

  const handleSuccessWithCertifiedPower = useCallback(
    async (data: any) => {
      await handleSuccess(data, certifiedPower, market);
    },
    [certifiedPower, market, handleSuccess],
  );

  return (
    <Create
      transform={transformFormValues}
      mutationOptions={{
        onSuccess: handleSuccessWithCertifiedPower,
        onError: handleError,
      }}
    >
      <SimpleForm>
        <Box
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            columnGap: 2,
          }}
        >
          <SelectInput source="country" choices={countryChoices} defaultValue={SiteContryEnum.Finland} readOnly />

          <FormDataConsumer>
            {({ formData }) => {
              const { country } = formData;

              if (isFrance(country)) {
                return <Typography color="warning">Not implemented for France yet</Typography>;
              }

              return <FinlandFormFields setCertifiedPower={setCertifiedPower} setMarket={setMarket} />;
            }}
          </FormDataConsumer>
        </Box>
      </SimpleForm>
    </Create>
  );
};

export default GroupCertificationsCreate;
